import {
  Waves,
  Umbrella,
  Wind,
  Wifi,
  ChefHat,
  TreePalm,
  Sun,
  Tv,
  WashingMachine,
  Car,
  Coffee,
  BedDouble,
} from "lucide-react";
import { amenities } from "@/data/content";

const iconMap = {
  Waves,
  Umbrella,
  Wind,
  Wifi,
  ChefHat,
  TreePalm,
  Sun,
  Tv,
  WashingMachine,
  Car,
  Coffee,
  BedDouble,
};

export default function Amenities() {
  return (
    <section
      id="amenities"
      data-testid="amenities-section"
      className="py-20 md:py-28 bg-[#FAF7F2]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="overline">What is included</p>
          <h2
            data-testid="amenities-title"
            className="font-serif-display text-4xl md:text-5xl mt-3 text-[#232E26]"
          >
            Everything you need, <em className="not-italic text-[#C65D47]">nothing extra.</em>
          </h2>
          <p className="mt-5 text-[#5B6E4A] leading-relaxed">
            The apartment is fully equipped so you can simply arrive, unpack
            and enjoy Halkidiki.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-[#5B6E4A]/15 border border-[#5B6E4A]/15">
          {amenities.map((a, i) => {
            const Icon = iconMap[a.icon];
            return (
              <div
                key={i}
                data-testid={`amenity-${i}`}
                className="bg-[#FAF7F2] p-6 md:p-8 flex items-center gap-4 hover:bg-[#EAE0D5]/60 transition-colors"
              >
                <div className="h-10 w-10 rounded-full bg-[#EAE0D5] flex items-center justify-center shrink-0">
                  {Icon && <Icon size={18} className="text-[#C65D47]" />}
                </div>
                <span className="text-[#232E26] text-[15px]">{a.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
